import { render, staticRenderFns } from "./CabecalhoRelatorio.vue?vue&type=template&id=1589322c&scoped=true"
import script from "./CabecalhoRelatorio.vue?vue&type=script&lang=js"
export * from "./CabecalhoRelatorio.vue?vue&type=script&lang=js"
import style0 from "./CabecalhoRelatorio.vue?vue&type=style&index=0&id=1589322c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1589322c",
  null
  
)

export default component.exports